import { type DoctorProfileData, TelegramUserStatus } from 'chaika-frontend-types/frontend-cms';

export function isTelegramUserActive(siteProfile: DoctorProfileData | null | undefined): boolean {
    return siteProfile?.telegramUserStatus === TelegramUserStatus.Active;
}
